export const environment = {
    production: true,
    api: 'https://feature41206.api.classichub.co.nz',
    buildVersion: '2026.5.29.1',
    uri: 'https://feature41206.classichub.co.nz',
    envName: 'feature41206',
    isTest: true,
};

